import config from './index.json'

const host = location.host

const devDomains = ['dev.', 'localhost', 'd380t35v6gg4p1']

const currentEnv = devDomains.some(domain => host.includes(domain)) ? 'development' : 'production'

export const environments = {
	vcpode: config[currentEnv]?.vcpode || config.production.vcpode,
	lif: config[currentEnv]?.lif || config.production.lif,
}
